import { IS_ANDROID, IS_IOS } from '@google/model-viewer/lib/constants';
import axios from 'axios';
import * as TO from 'fp-ts/TaskOption';
import { pipe } from 'fp-ts/function';
import { GltfBlob, ModelJson } from '../useRenderer';
import { ServiceConfig } from '@fixtuur/backpack';

/**
 * Construct a Model URL for the current Configuration furniture.
 */
export function getFurnitureArModel(
    serviceConfig: ServiceConfig.ServiceConfig,
    gltfBlob: GltfBlob,
    modelJson: ModelJson,
): TO.TaskOption<string> {
    if (IS_IOS) {
        return pipe(
            gltfBlob,
            TO.map(blob => URL.createObjectURL(blob)),
        );
    } else if (IS_ANDROID) {
        return pipe(
            modelJson,
            TO.chain(request => {
                return TO.tryCatch(() => {
                    return axios.post(`${serviceConfig.modelGenerator}/model-generate`, request, {
                        responseType: 'text',
                    });
                });
            }),
            TO.map(response => response.data as string),
        );
    } else {
        return TO.none;
    }
}
